import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

export default function ConfirmModal({ title, text, modalOpen = false, onConfirm, onDisagree }) {
	const [open, setOpen] = useState(modalOpen);
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

	useEffect(() => {
		setOpen(modalOpen);
	}, [modalOpen]);

	const handleClose = () => {
		onDisagree();
		setOpen(false);
	};

	return (
		<div>
			<Dialog fullScreen={fullScreen} open={open} onClose={handleClose} aria-labelledby="responsive-dialog-title">
				<DialogTitle id="responsive-dialog-title">{title}</DialogTitle>
				<DialogContent>
					<DialogContentText>{text}</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={onConfirm} color="primary" autoFocus>
						Agree
					</Button>
					<Button style={{ marginRight: "auto" }} autoFocus onClick={handleClose} color="secondary">
						Disagree
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}
